import React, { MouseEvent } from "react";
import { Button } from "@chakra-ui/react";
import { useClassroomSessionStore } from "@/stores/v2/classroomSessionStore";
import { useTranslation } from "react-i18next";

interface StartClassButtonProps {
	classroomName: string;
	disabled: boolean;
}

export function StartClassButton({ classroomName, disabled }: StartClassButtonProps): JSX.Element {
	const { t } = useTranslation();
	const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
		e.stopPropagation();
		useClassroomSessionStore.getState().handleShowStartClassModal({
			show: true,
			classroomName: classroomName,
			monitoring: false,
		});
	};

	return (
		<Button onClick={handleClick} isDisabled={disabled} py={0}>
			{t("classroomDetails.startClass")}
		</Button>
	);
}
